import {
  WORKFLOW_CONDITION_EQUALS,
  WORKFLOW_CONDITION_GREATER_EQUAL_THAN,
  WORKFLOW_CONDITION_GREATER_THAN,
  WORKFLOW_CONDITION_LESSER_EQUAL_THAN,
  WORKFLOW_CONDITION_LESSER_THAN,
  WORKFLOW_CONDITION_NOT_EQUAL
} from 'Constants/'
import { FormElement, Select } from 'mailup-web-components'
import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useMemo, useState } from 'react'

import { useIntl } from 'react-intl'

import { useRecoilValue, useSetRecoilState } from 'recoil'

const numericConditions = [
  {
    value: WORKFLOW_CONDITION_EQUALS,
    label: 'Load.AutomationWorkflow.TriggerCondition-7'
  },
  {
    value: WORKFLOW_CONDITION_GREATER_THAN,
    label: 'Load.AutomationWorkflow.TriggerCondition-8'
  },
  {
    value: WORKFLOW_CONDITION_GREATER_EQUAL_THAN,
    label: 'Load.AutomationWorkflow.TriggerCondition-9'
  },
  {
    value: WORKFLOW_CONDITION_LESSER_THAN,
    label: 'Load.AutomationWorkflow.TriggerCondition-10'
  },
  {
    value: WORKFLOW_CONDITION_LESSER_EQUAL_THAN,
    label: 'Load.AutomationWorkflow.TriggerCondition-11'
  },
  {
    value: WORKFLOW_CONDITION_NOT_EQUAL,
    label: 'Load.AutomationWorkflow.TriggerCondition-12'
  }
]

const InputIdFieldFilterNumeric = () => {
  const intl = useIntl()
  const [isDirty, setIsDirty] = useState(false)

  const { IdFieldFilter, FieldType } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const handleIdFiledFilterChange = (value) => {
    setWorkflowDetailsState((prev) => ({ ...prev, IdFieldFilter: value }))
    setIsDirty(true)
  }

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const idFieldFilterOptions = useMemo(() => {
    return numericConditions.map(({ label, value }) => ({
      value,
      label: intl.formatMessage({ id: label })
    }))
  }, [FieldType])

  const invalid = isDirty && !IdFieldFilter

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.SelectFieldConditionLabel'
      })}
      required
      feedback={invalid ? requiredFeedback : undefined}
      variant={invalid ? 'danger' : undefined}
    >
      <Select
        value={IdFieldFilter}
        options={idFieldFilterOptions}
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectTypeConditionPlaceholder'
        })}
        onChange={handleIdFiledFilterChange}
        error={invalid}
      />
    </FormElement>
  )
}

export default InputIdFieldFilterNumeric
